import React from 'react';
import { CONFIG } from '../../config';
import { Github, Linkedin, Mail, Phone, Heart } from 'lucide-react';

/**
 * Footer Component
 * 
 * Displays the website footer with contact information, social links, and copyright.
 * Uses lucide-react icons for visual elements.
 */
const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-slate-900 border-t border-white/5 pt-16 pb-8 px-6">
            <div className="max-w-7xl mx-auto">
                <div className="grid md:grid-cols-3 gap-12 mb-12">

                    {/* Brand Section: Logo and Tagline */}
                    <div className="space-y-4">
                        <h3 className="text-2xl font-bold text-white flex items-center gap-2">
                            <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-purple-600 to-indigo-600 flex items-center justify-center text-white text-sm">LM</span>
                            {CONFIG.personal.name}
                        </h3>
                        <p className="text-slate-400 text-sm leading-relaxed max-w-xs">
                            {CONFIG.personal.tagline}
                        </p>
                    </div>

                    {/* Quick Contact Information */}
                    <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-white">Contact Info</h4>
                        <div className="space-y-3">
                            <a href={`mailto:${CONFIG.personal.email}`} className="flex items-center gap-3 text-slate-400 hover:text-purple-400 transition-colors">
                                <Mail size={18} />
                                <span>{CONFIG.personal.email}</span>
                            </a>
                            <div className="flex items-center gap-3 text-slate-400">
                                <Phone size={18} />
                                <span>{CONFIG.personal.phone}</span>
                            </div>
                        </div>
                    </div>

                    {/* Social Media Links */}
                    <div className="space-y-4">
                        <h4 className="text-lg font-semibold text-white">Connect</h4>
                        <div className="flex gap-4">
                            <a
                                href={CONFIG.personal.github}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-purple-600 hover:text-white transition-all hover:-translate-y-1"
                            >
                                <Github size={20} />
                            </a>
                            <a
                                href={CONFIG.personal.linkedin}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white transition-all hover:-translate-y-1"
                            >
                                <Linkedin size={20} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-slate-500">
                    <p>© {currentYear} {CONFIG.personal.name}. All rights reserved.</p>
                    <p className="flex items-center gap-1">
                        Made with <Heart size={14} className="text-red-500 fill-red-500" /> using React & Tailwind
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
